import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationOfferTimeout = ({ entry, }) => {
    const authorName = getAuthorName(entry);
    const authorLink = authorName ? (_jsx(UserLink, Object.assign({ userId: entry.author.id }, { children: authorName }))) : null;
    const text = (_jsxs(_Fragment, { children: ["Conversation offer is timed out ", authorLink && _jsxs(_Fragment, { children: ["for ", authorLink] })] }));
    return _jsx(LogEntry, { entry: entry, text: text });
};
